import { InterFontProps, RobotoFontProps } from "./consts";
import { FontFamilyByWeight, TextProps } from "./types";

export const getFontFamilyProps = (
  family: TextProps["family"],
  fontWeight: number
): FontFamilyByWeight => {
  if (!fontWeight) return InterFontProps[400];

  switch (family) {
    case "roboto": {
      return RobotoFontProps[fontWeight];
    }
    case "inter": {
      return InterFontProps[fontWeight];
    }
    default:
      return InterFontProps[fontWeight];
  }
};
